import { render } from "./uiDescriptionListDefinition.vue?vue&type=template&id=4cf66e7e"
import script from "./uiDescriptionListDefinition.vue?vue&type=script&lang=js"
export * from "./uiDescriptionListDefinition.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__